/**
 * useRecorder — Platform-aware recording hook.
 * Native (Android/iOS): delegates to useNativeRecorder (custom Capacitor plugin).
 * Web (browser): delegates to useWebRecorder (MediaRecorder + IndexedDB).
 *
 * Same return interface for both — components don't need to know the platform.
 */

import { Capacitor } from "@capacitor/core";
import { useNativeRecorder } from "./useNativeRecorder";
import { useWebRecorder } from "./useWebRecorder";

export type { RecorderStatus } from "./useWebRecorder";

export function useRecorder(projectId: string) {
  if (Capacitor.isNativePlatform()) {
    return useNativeRecorder(projectId);
  }
  return useWebRecorder(projectId);
}
